import { render, staticRenderFns } from "./DialogProdutosDispInsumos.vue?vue&type=template&id=7d40a12a&"
import script from "./DialogProdutosDispInsumos.vue?vue&type=script&lang=js&"
export * from "./DialogProdutosDispInsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports